import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

export const DEFAULT_LPY_TYPE: NonNullable<Filters['lpuType']> = {
  id: 0,
  name: 'Любой',
  translit: 'default-item',
}
